import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { shopApi } from "./shopApi";

export const useShopSeoSettings = () => {
  const queryClient = useQueryClient();

  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.SEO_SETTINGS(),
    queryFn: () => shopApi.fetchSeoSettings(),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.SEO_SETTINGS(),
    });
  };

  return {
    isLoading,
    isFetching,
    seoSettings: data?.data,
    invalidate,
  };
};
